module.exports = __webpack_public_path__ + "static/media/frame.tablet.088913fa.png";